module.exports = __webpack_public_path__ + "img/DSC_1145.d8e19326.jpg";